import React from 'react';

import DropDownItem from '../../../shared/items/contols/dropDownItem'
import { sortCarsTypes } from './static.sortCarsTypes'

const SortCarsDropdownMenu = props => {
  const { handleChooseType } = props

  return (
    sortCarsTypes.map((item, key) => {
      return (
        <DropDownItem key={key}>
          <button onClick={handleChooseType.bind(this, item.type)}>{item.title}</button>
        </DropDownItem>
      )
    })
  )
}

export default React.memo(SortCarsDropdownMenu)
